export enum CaptchaType {
  REGISTRATION = "REGISTRATION",
}
